/**
 * Bíblia: pegar um trecho e inserir no texto.
 *
 * O recurso é para quem escreve sermão, estudo, devocional, aula de escola
 * dominical — e o que ele precisa é colar o versículo com a referência no formato
 * que a igreja usa: **1 Co 15:21-24 - Almeida**.
 *
 * ## Sobre a versão
 *
 * Só entra tradução em **domínio público**. A NVI, a ARA, a NTLH e a ACF estão
 * protegidas por direito autoral e **não** podem ser distribuídas por aqui — usar
 * "NVI" no rótulo sem a licença seria violação, e o site não faz isso. A versão
 * disponível é a **João Ferreira de Almeida**, de domínio público, servida pela
 * API pública `bible-api.com`.
 *
 * O rótulo da versão é um texto livre (`versao`): quem tiver licença de outra
 * tradução e a servir por conta própria pode trocar o nome no painel — mas o
 * gerador não traz o texto protegido.
 *
 * ## O que este módulo faz
 *
 * - a **tabela dos 66 livros** com as abreviações que se usam no Brasil, para a
 *   referência sair curta (`1 Coríntios` → `1 Co`);
 * - a **formatação da referência** a partir do que a API devolve;
 * - os **três modos de inserção** (só a referência, texto e referência, ou a
 *   referência no texto com o trecho numa caixa cinza logo abaixo).
 */
export const LIVROS_DA_BIBLIA = [
    { nome: 'Gênesis', abrev: 'Gn', apelidos: ['genesis', 'gen'], testamento: 'ANTIGO' },
    { nome: 'Êxodo', abrev: 'Êx', apelidos: ['exodo', 'ex'], testamento: 'ANTIGO' },
    { nome: 'Levítico', abrev: 'Lv', apelidos: ['levitico', 'lev'], testamento: 'ANTIGO' },
    { nome: 'Números', abrev: 'Nm', apelidos: ['numeros', 'num'], testamento: 'ANTIGO' },
    { nome: 'Deuteronômio', abrev: 'Dt', apelidos: ['deuteronomio', 'deut'], testamento: 'ANTIGO' },
    { nome: 'Josué', abrev: 'Js', apelidos: ['josue', 'jos'], testamento: 'ANTIGO' },
    { nome: 'Juízes', abrev: 'Jz', apelidos: ['juizes', 'juiz'], testamento: 'ANTIGO' },
    { nome: 'Rute', abrev: 'Rt', apelidos: ['rute'], testamento: 'ANTIGO' },
    { nome: '1 Samuel', abrev: '1 Sm', apelidos: ['1 samuel', '1 sam'], testamento: 'ANTIGO' },
    { nome: '2 Samuel', abrev: '2 Sm', apelidos: ['2 samuel', '2 sam'], testamento: 'ANTIGO' },
    { nome: '1 Reis', abrev: '1 Rs', apelidos: ['1 reis'], testamento: 'ANTIGO' },
    { nome: '2 Reis', abrev: '2 Rs', apelidos: ['2 reis'], testamento: 'ANTIGO' },
    { nome: '1 Crônicas', abrev: '1 Cr', apelidos: ['1 cronicas', '1 cron'], testamento: 'ANTIGO' },
    { nome: '2 Crônicas', abrev: '2 Cr', apelidos: ['2 cronicas', '2 cron'], testamento: 'ANTIGO' },
    { nome: 'Esdras', abrev: 'Ed', apelidos: ['esdras'], testamento: 'ANTIGO' },
    { nome: 'Neemias', abrev: 'Ne', apelidos: ['neemias'], testamento: 'ANTIGO' },
    { nome: 'Ester', abrev: 'Et', apelidos: ['ester'], testamento: 'ANTIGO' },
    { nome: 'Jó', abrev: 'Jó', apelidos: ['jó'], testamento: 'ANTIGO' },
    { nome: 'Salmos', abrev: 'Sl', apelidos: ['salmos', 'salmo', 'sl'], testamento: 'ANTIGO' },
    { nome: 'Provérbios', abrev: 'Pv', apelidos: ['proverbios', 'prov'], testamento: 'ANTIGO' },
    { nome: 'Eclesiastes', abrev: 'Ec', apelidos: ['eclesiastes', 'ecl'], testamento: 'ANTIGO' },
    { nome: 'Cânticos', abrev: 'Ct', apelidos: ['canticos', 'cantares', 'cantico dos canticos'], testamento: 'ANTIGO' },
    { nome: 'Isaías', abrev: 'Is', apelidos: ['isaias', 'isa'], testamento: 'ANTIGO' },
    { nome: 'Jeremias', abrev: 'Jr', apelidos: ['jeremias', 'jer'], testamento: 'ANTIGO' },
    { nome: 'Lamentações', abrev: 'Lm', apelidos: ['lamentacoes', 'lam'], testamento: 'ANTIGO' },
    { nome: 'Ezequiel', abrev: 'Ez', apelidos: ['ezequiel', 'eze'], testamento: 'ANTIGO' },
    { nome: 'Daniel', abrev: 'Dn', apelidos: ['daniel', 'dan'], testamento: 'ANTIGO' },
    { nome: 'Oseias', abrev: 'Os', apelidos: ['oseias', 'os', 'oseias'], testamento: 'ANTIGO' },
    { nome: 'Joel', abrev: 'Jl', apelidos: ['joel'], testamento: 'ANTIGO' },
    { nome: 'Amós', abrev: 'Am', apelidos: ['amos'], testamento: 'ANTIGO' },
    { nome: 'Obadias', abrev: 'Ob', apelidos: ['obadias', 'abdias'], testamento: 'ANTIGO' },
    { nome: 'Jonas', abrev: 'Jn', apelidos: ['jonas'], testamento: 'ANTIGO' },
    { nome: 'Miqueias', abrev: 'Mq', apelidos: ['miqueias', 'miq'], testamento: 'ANTIGO' },
    { nome: 'Naum', abrev: 'Na', apelidos: ['naum'], testamento: 'ANTIGO' },
    { nome: 'Habacuque', abrev: 'Hc', apelidos: ['habacuque', 'hab'], testamento: 'ANTIGO' },
    { nome: 'Sofonias', abrev: 'Sf', apelidos: ['sofonias', 'sof'], testamento: 'ANTIGO' },
    { nome: 'Ageu', abrev: 'Ag', apelidos: ['ageu'], testamento: 'ANTIGO' },
    { nome: 'Zacarias', abrev: 'Zc', apelidos: ['zacarias', 'zac'], testamento: 'ANTIGO' },
    { nome: 'Malaquias', abrev: 'Ml', apelidos: ['malaquias', 'mal'], testamento: 'ANTIGO' },
    { nome: 'Mateus', abrev: 'Mt', apelidos: ['mateus', 'mat'], testamento: 'NOVO' },
    { nome: 'Marcos', abrev: 'Mc', apelidos: ['marcos', 'mar'], testamento: 'NOVO' },
    { nome: 'Lucas', abrev: 'Lc', apelidos: ['lucas', 'luc'], testamento: 'NOVO' },
    { nome: 'João', abrev: 'Jo', apelidos: ['joao', 'jo'], testamento: 'NOVO' },
    { nome: 'Atos', abrev: 'At', apelidos: ['atos', 'atos dos apostolos'], testamento: 'NOVO' },
    { nome: 'Romanos', abrev: 'Rm', apelidos: ['romanos', 'rom'], testamento: 'NOVO' },
    { nome: '1 Coríntios', abrev: '1 Co', apelidos: ['1 corintios', '1 cor'], testamento: 'NOVO' },
    { nome: '2 Coríntios', abrev: '2 Co', apelidos: ['2 corintios', '2 cor'], testamento: 'NOVO' },
    { nome: 'Gálatas', abrev: 'Gl', apelidos: ['galatas', 'gal'], testamento: 'NOVO' },
    { nome: 'Efésios', abrev: 'Ef', apelidos: ['efesios', 'efe'], testamento: 'NOVO' },
    { nome: 'Filipenses', abrev: 'Fp', apelidos: ['filipenses', 'fil'], testamento: 'NOVO' },
    { nome: 'Colossenses', abrev: 'Cl', apelidos: ['colossenses', 'col'], testamento: 'NOVO' },
    { nome: '1 Tessalonicenses', abrev: '1 Ts', apelidos: ['1 tessalonicenses', '1 tes'], testamento: 'NOVO' },
    { nome: '2 Tessalonicenses', abrev: '2 Ts', apelidos: ['2 tessalonicenses', '2 tes'], testamento: 'NOVO' },
    { nome: '1 Timóteo', abrev: '1 Tm', apelidos: ['1 timoteo', '1 tim'], testamento: 'NOVO' },
    { nome: '2 Timóteo', abrev: '2 Tm', apelidos: ['2 timoteo', '2 tim'], testamento: 'NOVO' },
    { nome: 'Tito', abrev: 'Tt', apelidos: ['tito'], testamento: 'NOVO' },
    { nome: 'Filemom', abrev: 'Fm', apelidos: ['filemom', 'filemon'], testamento: 'NOVO' },
    { nome: 'Hebreus', abrev: 'Hb', apelidos: ['hebreus', 'heb'], testamento: 'NOVO' },
    { nome: 'Tiago', abrev: 'Tg', apelidos: ['tiago', 'tia'], testamento: 'NOVO' },
    { nome: '1 Pedro', abrev: '1 Pe', apelidos: ['1 pedro', '1 pe'], testamento: 'NOVO' },
    { nome: '2 Pedro', abrev: '2 Pe', apelidos: ['2 pedro', '2 pe'], testamento: 'NOVO' },
    { nome: '1 João', abrev: '1 Jo', apelidos: ['1 joao', '1 jo'], testamento: 'NOVO' },
    { nome: '2 João', abrev: '2 Jo', apelidos: ['2 joao', '2 jo'], testamento: 'NOVO' },
    { nome: '3 João', abrev: '3 Jo', apelidos: ['3 joao', '3 jo'], testamento: 'NOVO' },
    { nome: 'Judas', abrev: 'Jd', apelidos: ['judas', 'jud'], testamento: 'NOVO' },
    { nome: 'Apocalipse', abrev: 'Ap', apelidos: ['apocalipse', 'apo'], testamento: 'NOVO' },
];
/** Sem acento, sem caixa alta e sem espaço sobrando — para comparar nomes. */
export function semAcentoNaBiblia(texto) {
    return texto
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
}
/**
 * A chave de comparação: sem acento, sem caixa alta, sem espaço e sem ponto.
 *
 * Sem tirar o espaço, `1Co` (como quase todo mundo digita) não achava
 * `1 Co`, e o pregador levava um "livro desconhecido" num nome que ele conhece
 * de cor. Com a chave sem espaço, `1Co`, `1 Co`, `1 co` e `1co` são o mesmo livro.
 */
function chaveDoLivro(texto) {
    return semAcentoNaBiblia(texto).replace(/[\s.]+/g, '');
}
const POR_APELIDO = new Map();
for (const livro of LIVROS_DA_BIBLIA) {
    POR_APELIDO.set(chaveDoLivro(livro.nome), livro);
    POR_APELIDO.set(chaveDoLivro(livro.abrev), livro);
    for (const apelido of livro.apelidos)
        POR_APELIDO.set(chaveDoLivro(apelido), livro);
}
/** O livro pelo nome, pela abreviação ou por um apelido (`1 cor`, `1Co`, `João`). */
export function livroDaBiblia(nome) {
    return POR_APELIDO.get(chaveDoLivro(nome)) ?? null;
}
/** A abreviação de um nome de livro; devolve o próprio nome quando não conhece. */
export function abreviarLivro(nome) {
    return livroDaBiblia(nome)?.abrev ?? nome.trim();
}
/* ------------------------------------------------------------------ */
/* A referência                                                       */
/* ------------------------------------------------------------------ */
/** A versão em domínio público que o site serve. */
export const VERSAO_PADRAO_DA_BIBLIA = 'Almeida';
/**
 * A referência curta: `1 Co 15:21-24 - Almeida`.
 *
 * Um versículo só perde o intervalo (`Jo 3:16 - Almeida`); um capítulo inteiro
 * mantém o número do versículo inicial, porque é assim que se cita na igreja.
 */
export function referenciaBiblica(trecho, versao = VERSAO_PADRAO_DA_BIBLIA) {
    const livro = abreviarLivro(trecho.livro);
    const intervalo = trecho.versiculoFinal > trecho.versiculoInicial
        ? `${trecho.versiculoInicial}-${trecho.versiculoFinal}`
        : String(trecho.versiculoInicial);
    return `${livro} ${trecho.capitulo}:${intervalo} - ${versao}`;
}
/** Só `1 Co 15:21-24`, sem a versão — para citar dentro da frase. */
export function referenciaCurta(trecho) {
    const livro = abreviarLivro(trecho.livro);
    const intervalo = trecho.versiculoFinal > trecho.versiculoInicial
        ? `${trecho.versiculoInicial}-${trecho.versiculoFinal}`
        : String(trecho.versiculoInicial);
    return `${livro} ${trecho.capitulo}:${intervalo}`;
}
/** O texto corrido dos versículos, sem os números. */
export function textoDoTrecho(trecho) {
    return trecho.versos
        .map((verso) => verso.texto.replace(/\s+/g, ' ').trim())
        .filter(Boolean)
        .join(' ');
}
/**
 * O texto com o número na frente de cada versículo — o jeito que se lê na Bíblia.
 *
 * Número sobrescrito e em negrito leve: `²¹ Porque, assim como…`.
 */
export function textoNumeradoDoTrecho(trecho) {
    return trecho.versos
        .map((verso) => `<sup><strong>${verso.numero}</strong></sup> ${escapar(verso.texto.replace(/\s+/g, ' ').trim())}`)
        .join(' ');
}
function escapar(texto) {
    return texto.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
/* ------------------------------------------------------------------ */
/* Os três modos de inserção                                          */
/* ------------------------------------------------------------------ */
export const MODOS_DE_INSERCAO_BIBLICA = ['REFERENCIA', 'TEXTO_E_REFERENCIA', 'CAIXA_ABAIXO'];
export const ROTULO_MODO_DE_INSERCAO = {
    REFERENCIA: 'Só a referência',
    TEXTO_E_REFERENCIA: 'O texto e, depois, a referência',
    CAIXA_ABAIXO: 'O versículo à parte, com a referência embaixo',
};
export const DESCRICAO_MODO_DE_INSERCAO = {
    REFERENCIA: 'Cola só “1 Co 15:21-24 - Almeida”, para citar no meio da frase.',
    TEXTO_E_REFERENCIA: 'Cola o versículo e, na linha de baixo, a referência.',
    CAIXA_ABAIXO: 'Põe o versículo numa caixa cinza, em itálico e na fonte do texto, e a referência logo abaixo, depois de um travessão.',
};
/** O travessão que separa o versículo da referência (`—`). */
export const TRAVESSAO = '\u2014';
/** O estilo da caixa do terceiro modo: cinza, itálico, texto preto. */
export const ESTILO_DA_CAIXA_BIBLICA = 'background-color:#f2f2f2;color:#000000;font-style:italic;padding:8px 12px;margin:6px 0;border-left:3px solid #d4d4d4;';
/**
 * O HTML que entra no editor, no modo escolhido.
 *
 * No terceiro modo (o versículo **à parte**), a ordem é a de quem lê: primeiro o
 * versículo, na caixa cinza em itálico, e **depois** a referência, precedida de um
 * travessão — `— 1 Co 15:21-24 - Almeida`. Assim a citação fecha na assinatura da
 * fonte, como se escreve no sermão, e não começa por ela.
 */
export function htmlDaInsercaoBiblica(trecho, modo, versao = VERSAO_PADRAO_DA_BIBLIA) {
    const referencia = referenciaBiblica(trecho, versao);
    if (modo === 'REFERENCIA') {
        return `(${escapar(referencia)})`;
    }
    if (modo === 'TEXTO_E_REFERENCIA') {
        return `<p style="font-style:italic;">${textoNumeradoDoTrecho(trecho)} (${escapar(referencia)})</p>`;
    }
    /*
     * A referência fica **fora** da caixa: a caixa é a citação, e o que está dentro
     * dela é o texto inspirado. A fonte assina embaixo, depois do travessão.
     */
    return (`<p style="${ESTILO_DA_CAIXA_BIBLICA}">${textoNumeradoDoTrecho(trecho)}</p>` +
        `<p style="margin:0 0 12px 0;">${TRAVESSAO} ${escapar(referencia)}</p>`);
}
//# sourceMappingURL=biblia.js.map